import type Model from '@netx/core/lib/netx-model';
import _ from 'underscore';

import {useEffect, useState} from 'react';
import useComponentIsMounted from './useComponentIsMounted';

/**
 * Handles piping a backbone model into a react state
 * @deprecated
 */
export function useBackboneModel<TModel extends Model = Model>(
	model: TModel,
	fetchOnMount = true,
) {
	const {act} = useComponentIsMounted();

	const [attributes, setAttributes] = useState<TModel['attributes']>({});

	// Subscribe to the model on first render only
	useEffect(() => {
		const pullAndSetData = () =>
			act(() => setAttributes({...model.attributes}));

		pullAndSetData();

		model.on('change', pullAndSetData);

		const preferredFetchMethod = model.preferredFetchMethod || 'fetch';
		// @ts-ignore
		fetchOnMount !== false && model[preferredFetchMethod]();

		// Unsubscribe when component unmounted
		return () => {
			model.off(undefined, pullAndSetData);
		};
	}, []);

	return attributes;
}

export default useBackboneModel;
